import { useApp } from '@libs/hooks';
import { ECalculatorErrorType, TCalculatorError, TCommonData, TCommonDataObj, TWidget } from '@libs/types';
import { SplitText } from '@libs/utils';
import React, { useState } from 'react';
import { ButtonPillView } from '../../Buttons/ButtonPillView';
import { ButtonRowView } from '../../Buttons/ButtonRowView';
import { InputWrapper } from '../../UI/Wrapper/InputWrapper';
import { PopupComponent } from '../../UI/Popup/PopupComponent';
import { ActionNameEnum, InputEnum, TServerCalculationFunc } from '../utils/types';
import { CodeTimerScreen } from './CodeTimerScreen';

type TPromoCode = {
    text?: string;
    textLock?: string;
    textAddedCode?: string;
    label?: string;
    labelGotIt?: string;
    isFrom: boolean;
    onServerCalculation: TServerCalculationFunc;
};
const CodeInput = ({ text, label, isFrom, onServerCalculation, textLock, labelGotIt, textAddedCode }: TPromoCode) => {
    const { setPopup, setModal } = useApp();
    const [value, setValue] = useState('');
    const [isFocused, setIsFocused] = useState<boolean>(true);
    const [currentError, setCurrentError] = useState<TCalculatorError | undefined>(undefined);
    const [isFilled, setIsFilled] = useState<boolean>(!!value);
    const isEnabled = Boolean(value && !currentError);
    const lockError = currentError?.type === ECalculatorErrorType.INVALID_CODE_LOCK;

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const value = e?.target?.value;
        setIsFocused(false);
        setIsFilled(!!value);
    };

    const handleFocus = () => {
        setIsFilled(true);
        setIsFocused(true);
        setCurrentError(undefined);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (currentError?.shortText && !lockError) {
            setCurrentError(undefined);
        }
        setValue(e.target.value);
    };
    const handleClick = async () => {
        if (value) {
            const result = await onServerCalculation(value, 'code', isFrom, ActionNameEnum.onAddCode);
            if (result?.errors?.code) {
                setCurrentError(result?.errors?.code);
            } else if (result?.value && typeof result.value !== 'string' && (result.value as TCommonDataObj)?.code) {
                setPopup(null);
                setModal(<CodeTimerScreen text={textAddedCode} />);
            } else {
                setPopup(null);
            }
        }
    };

    const handleErrorClick = () => {
        setPopup(
            <PopupComponent
                header={<SplitText text={textLock ?? ''} />}
                externalContent={[<ButtonRowView key="got it" label={labelGotIt} iconName={'ic_check'} onClick={() => setPopup(null)} />]}
            />,
        );
    };
    return (
        <>
            <SplitText text={text ?? ''} />
            <InputWrapper
                widget={{} as TWidget<TCommonData>}
                alignCenter
                isFocused={isFocused}
                isError={!!currentError?.shortText}
                errorMessage={currentError?.shortText}
                isFilled={isFilled}
                isShowErrorHintButton={lockError}
                handleErrorClick={handleErrorClick}
                marginTop={48}
                marginBottom={48}
            >
                <input
                    autoFocus
                    value={value}
                    name={InputEnum.CODE}
                    style={{ textAlign: 'center' }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    type="text"
                />
            </InputWrapper>
            <ButtonPillView hierarchy="primary" position="floating" label={label ?? ''} onClick={handleClick} isDisabled={!isEnabled} />
        </>
    );
};
export { CodeInput };
